import React, { useState } from "react";
import { Grid, IconButton, Tooltip, Typography, Divider } from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import CloseIcon from "@mui/icons-material/Close";

const WarehouseMappingActionMenu = ({
  isEdit,
  onSave,
  onDelete,
  onClear,
  onExit,
  onSetEditMode,
  saveDisabled,
}) => {
  const [selectedButton, setSelectedButton] = useState(null);

  const handleClick = (btn) => {
    setSelectedButton(btn);
    switch (btn) {
      case "save":
        onSave?.();
        break;
      case "delete":
        onDelete?.();
        break;
      case "clear":
        onClear?.();
        onSetEditMode?.(false);
        break;
      case "exit":
        onExit?.();
        break;
      default:
        break;
    }
  };

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      padding={0}
    >
      {/* Title */}
      <Grid item>
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            width: "100%",
            marginLeft: "10px",
            alignItems: "center",
          }}
        >
          {isEdit ? "Edit Warehouse Mapping" : "New Warehouse Mapping"}
        </Typography>
      </Grid>

      {/* Action Buttons */}
      <Grid item>
        <Grid container alignItems="center">
          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Save */}
          <Grid item ml={1} mr={1}>
            <Tooltip title="Save Warehouse Mapping">
              <IconButton
                onClick={() => handleClick("save")}
                sx={{ display: "flex", alignItems: "center" }}
                disabled={saveDisabled}
              >
                <SaveAltIcon
                  style={{
                    fontSize: "18px",
                    color: selectedButton === "save" ? "yellow" : "#009688",
                  }}
                />
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Save
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          {/* Delete (only for edit mode) */}
          {isEdit && (
            <>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
              <Grid item ml={1} mr={1}>
                <Tooltip title="Delete Warehouse Mapping">
                  <IconButton
                    onClick={() => handleClick("delete")}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <DeleteIcon
                      style={{ fontSize: "18px", color: "#d72c0dff" }}
                    />
                    <Typography variant="body2" sx={{ ml: 1 }}>
                      Delete
                    </Typography>
                  </IconButton>
                </Tooltip>
              </Grid>
            </>
          )}

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Clear */}
          <Grid item ml={1} mr={1}>
            <Tooltip title="Clear Warehouse Mapping Details">
              <IconButton
                onClick={() => handleClick("clear")}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <ClearAllIcon
                  style={{ fontSize: "18px", color: "#e0d620ff" }}
                />
                <Typography variant="body2" sx={{ ml: 1 }}>
                  Clear
                </Typography>
              </IconButton>
            </Tooltip>
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          {/* Exit */}
          <Tooltip title="Close Form">
            <IconButton onClick={() => handleClick("exit")}>
              <CloseIcon style={{ fontSize: "14px", color: "#2196F3" }} />
            </IconButton>
          </Tooltip>

          <Divider orientation="vertical" flexItem />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WarehouseMappingActionMenu;
